import { useCallback, useMemo } from 'react';
import { SidebarPanels, useSettings } from '@/entities/settings';

export const useMainSidebar = () => {
  const { sidebar: sidebarSettings, setSidebarSettings } = useSettings();
  const activePanel = sidebarSettings.activePanel || 'navigation';
  const copilotWidth = sidebarSettings.copilotWidth ?? 480;
  const isOpen = sidebarSettings.isOpen ?? true;

  const setActivePanel = useCallback(
    (panel: SidebarPanels) => setSidebarSettings({ activePanel: panel }),
    [setSidebarSettings],
  );

  const setCopilotWidth = useCallback(
    (width: number) => setSidebarSettings({ copilotWidth: width }),
    [setSidebarSettings],
  );

  const setIsOpen = useCallback((open: boolean) => setSidebarSettings({ isOpen: open }), [setSidebarSettings]);

  return useMemo(
    () => ({ activePanel, setActivePanel, copilotWidth, setCopilotWidth, isOpen, setIsOpen }),
    [activePanel, setActivePanel, copilotWidth, setCopilotWidth, isOpen, setIsOpen],
  );
};
